export default {
    rightsReserved: 'Todos los derechos reservados',
    generalConditionsLink: '/condiciones-generales',
    generalConditions: 'Condiciones Generales',
    frequentQuestionsLink: '/ayuda',
    frequentQuestions: 'Preguntas Frecuentes',
    regretButton: 'Botón de arrepentimiento',
    regretButtonLink: 'https://p10-cdn.s3.amazonaws.com/p10botondearrepentimiento.pdf',
}